import { render, staticRenderFns } from "./403NotHeader.vue?vue&type=template&id=f34dd85a&scoped=true"
import script from "./403NotHeader.vue?vue&type=script&lang=js"
export * from "./403NotHeader.vue?vue&type=script&lang=js"
import style0 from "./403NotHeader.vue?vue&type=style&index=0&id=f34dd85a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34dd85a",
  null
  
)

export default component.exports